import React, { useMemo } from 'react';
import { TbLockOpen, TbLockOpenOff } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';
import Button from '../shared/buttons/Button';

const UsersTable = ({ users, loading, onUserClick, onUserBlockClick }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      users.map((user, i) => (
        <SelectableRow key={i} onClick={() => onUserClick(user)}>
          <Row children={user.userName} />
          <Row children={user.firstName} />
          <Row children={user.lastName} />
          {!isTabletView && (
            <Row
              children={
                <div>
                  {user.roles.map((role) => (
                    <li key={role.id}>{role.displayName}</li>
                  ))}
                </div>
              }
            />
          )}
          <Row
            children={
              <div title={`${user.isActive ? 'Заблокувати' : 'Розблокувати'}`} className="w-full text-end z-30">
                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    onUserBlockClick(user);
                  }}
                  variant="secondary2"
                  disabled={loading}
                >
                  {user.isActive ? <TbLockOpen size={20} /> : <TbLockOpenOff size={20} />}
                </Button>
              </div>
            }
          />
        </SelectableRow>
      )),
    [isTabletView, onUserBlockClick, loading, users, onUserClick],
  );

  return <Table columns={isTabletView ? mobileColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const mobileColumns = [
  { name: 'Логін', className: 'w-[30%]' },
  { name: "Ім'я", className: 'w-[30%]' },
  { name: 'Прізвище', className: 'w-[35%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

const columns = [
  { name: 'Логін', className: 'w-[20%]' },
  { name: "Ім'я", className: 'w-[20%]' },
  { name: 'Прізвище', className: 'w-[20%]' },
  { name: 'Ролі', className: 'w-[35%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default UsersTable;
